import { fullBase } from "@/components/apikeys/keyUtils";

const Row = ({ m, p, d }) => (
  <div className="py-2 flex flex-wrap gap-x-4 text-sm"><span className="font-mono text-xs w-14 text-[#C2410C] font-bold">{m}</span><span className="font-mono text-xs">{p}</span><span className="text-stone-600">{d}</span></div>
);

export const ApiDocs = ({ data }) => {
  const base = fullBase(data?.base_url);
  return (
    <div className="grid lg:grid-cols-2 gap-6" data-testid="api-docs">
      <div className="bg-white border border-stone-200 rounded-lg p-6">
        <h3 className="font-heading text-base font-bold text-stone-900">Adresse de l'API</h3>
        <code className="block mt-3 rounded-md bg-stone-100 px-3 py-2 font-mono text-xs break-all" data-testid="api-base-url">{base}</code>
        <p className="text-sm text-stone-600 mt-3">Chaque appel doit contenir l'en-tête <code className="font-mono text-xs bg-stone-100 px-1">X-API-Key</code>. Remplacez <code className="font-mono text-xs">{"{module}"}</code> par le nom technique (ex. <code className="font-mono text-xs">epi_cases</code>, <code className="font-mono text-xs">pathologies</code>).</p>
        <div className="mt-4 divide-y divide-stone-100">
          <Row m="GET" p="/" d="Infos et droits de la clé" />
          <Row m="GET" p="/{module}?limit=100&offset=0&updated_since=" d="Liste paginée" />
          <Row m="GET" p="/{module}/{id}" d="Un élément" />
          <Row m="PUT" p="/{module}/{id}" d="Modifier (droit d'écriture)" />
          <Row m="POST" p="/{module}" d="Créer (référentiels)" />
          <Row m="DELETE" p="/{module}/{id}" d="Supprimer (référentiels)" />
        </div>
      </div>
      <div className="bg-white border border-stone-200 rounded-lg p-6 space-y-3 text-sm">
        <h3 className="font-heading text-base font-bold text-stone-900">Exemple</h3>
        <pre className="rounded-md bg-stone-900 text-amber-200 p-4 text-xs overflow-x-auto">{`curl -H "X-API-Key: shp_votre_cle" \\\n  "${base}/epi_cases?limit=50"`}</pre>
        <h3 className="font-heading text-base font-bold text-stone-900 pt-2">Réponses d'erreur</h3>
        <div className="divide-y divide-stone-100 text-stone-700">
          {[["401", "Clé absente ou invalide"], ["403", "Clé révoquée, expirée, suspendue, IP non autorisée ou module non permis"], ["429", "Limite d'appels par minute dépassée (en-tête Retry-After)"], ["502", "Sehatic-Pedia a refusé ou n'a pas reçu la modification"]].map(([c, t]) => (
            <p key={c} className="py-1.5"><span className="font-mono text-xs font-bold mr-3">{c}</span>{t}</p>
          ))}
        </div>
      </div>
    </div>
  );
};
